import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { first } from 'rxjs/operators';
import { BaseWizardComponent } from '../base-wizard.component';
import { ISelfAuditDataModel as ISelfAuditDataModel, SelfAuditDataModel } from '../models/veg-wizard-models';
import { VegWizardDataService } from '../services/veg-wizard-data.service';


@UntilDestroy()
@Component({
  selector: 'app-self-audit',
  templateUrl: './self-audit.component.html',
  styleUrls: ['./self-audit.component.css'],
  imports: [
    ReactiveFormsModule
],
})
export class SelfAuditComponent extends BaseWizardComponent implements OnInit {

  get hasAuditEvidenceControl() { return this.form.controls['hasAuditEvidence']; }

  selfAuditData: ISelfAuditDataModel;
  nextWasPressedAtLeastOnce = false;

  form: FormGroup;
  sessionId = '';

  constructor(
    private formBuilder: FormBuilder,
    private vwds: VegWizardDataService,
    router: Router
  ) {
    super();

    // check session storage if selfAuditData hasAuditEvidence has been populated
    this.selfAuditData = this.vwds.getSelfAuditEvidence() ?? new SelfAuditDataModel();
    this.form = this.formBuilder.group({ hasAuditEvidence: [this.selfAuditData?.hasAuditEvidence, Validators.required] });
  }

  ngOnInit(): void {
    this.performValidations();

    this.form.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      this.selfAuditData.hasAuditEvidence = this.hasAuditEvidenceControl.value;

      this.performValidations();
    });
  }

  performValidations() {
    this.hasAuditEvidenceControl?.setErrors(null);

    if (!this.hasAuditEvidenceControl.value) {
      this.hasAuditEvidenceControl?.setErrors({ 'Required': true });
    }
  }

  override next() {
    this.form.markAsDirty();
    this.performValidations();

    if (!this.form.valid) {
      return;
    }

    this.vwds
      .setSelfAuditEvidence$(this.selfAuditData)
      .pipe(first(), untilDestroyed(this))
      .subscribe((success) => {
        if (success) {
          super.next();
        }
      });

  }

}

